export interface PlanItem {
  value: boolean | string;
  toolTip?: string;
  [key: string]: boolean | string | undefined;
}

export interface PlanData {
  freePlan: PlanItem;
  proPlan: PlanItem;
  proPlanPlus?: PlanItem;
  titleTooltip?: string;
  [key: string]: PlanItem | boolean | string | undefined;
}

export interface AddOns {
  price: boolean | string;
  toolTip?: string;
}

export const platformPricing = {
  'Base price': {
    freePlan: {value: '$0/mo'},
    proPlan: {value: '$25/mo'},
  },
  'Included MAUs': {
    freePlan: {value: '10,000'},
    proPlan: {value: '10,000'},
  },
  'Additional MAUs': {
    freePlan: {value: ' '},
    proPlan: {value: '$0.02/ea'},
  },
  'Included MAOs': {
    freePlan: {value: '100'},
    proPlan: {value: '100'},
  },
  'Additional MAOs': {
    freePlan: {value: ' '},
    proPlan: {value: '$1/ea'},
  },
  'Dashboard seats': {
    freePlan: {value: '3'},
    proPlan: {value: '3'},
  },
  'Additional seats': {
    freePlan: {value: '$10/mo/seat'},
    proPlan: {value: '$10/mo/seat'},
  },
  'Remove Clerk branding': {
    freePlan: {value: ' '},
    proPlan: {value: true},
  }
};

export const authenticationAndUserFeatures = {
  'Social connections': {
    freePlan: {value: 'Up to 3'},
    proPlan: {value: 'Unlimited'},
    proPlanPlus: {value: 'Unlimited'}
  },
  'Usernames': {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Passwords': {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Email codes': {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Email links': {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'SMS codes': {
    freePlan: {value: ' '},
    proPlan: {value: true},
    proPlanPlus: { value: true },
    titleTooltip: 'SMS Fees are based on country location'
  },
  "Sign in tokens": {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Automatic account linking': {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'User metadata': {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Webhooks & data sync': {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Custom password requirements': {
    freePlan: {value: ' '},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  "Custom email & SMS templates": {
    freePlan: {value: ' '},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Multifactor auth (SMS, TOTP, Backup Codes)': {
    freePlan: {value: ' '},
    proPlan: {value: ' '},
    proPlanPlus: {value: true}
  },
  'SAML Connections': {
    freePlan: {value: ' '},
    proPlan: {value: ' '},
    proPlanPlus: { value: "+$50 per connection" }
  },
};

  
export const securityFeatures = {
  'Account lockout / Brute-force protection': {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Bot protection': {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'User bans': {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Allowlist / blocklist': {
    freePlan: {value: ' '},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Block email subaddresses': {
    freePlan: {value: ' '},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Block disposable email addresses': {
    freePlan: {value: ' '},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },

};

export const sessionManagementFeatures = {
  'Custom session tokens': {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Custom JWT templates': {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Custom session duration': {
    freePlan: {value: ' '},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Device tracking and revocation': {
    freePlan: {value: ' '},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Simultaneous sessions': {
    freePlan: {value: ' '},
    proPlan: {value: ' '},
    proPlanPlus: { value: true },
    titleTooltip: 'Allow users to sign in to multiple accounts on one device'
  },
  'Satellite domains': {
    freePlan: {value: ' '},
    proPlan: {value: ' '},
    proPlanPlus: { value: '+$10 per domain' },
    titleTooltip: 'Allow additional “satellite” domains to inherit the session from the “primary” domain. '
  },
};


export const administrationAndDashboardFeatures = {
  'Dashboard seats': {
    freePlan: {value: '3'},
    proPlan: {value: '3'},
    proPlanPlus: {value: '3'}
  },
  'Additional seats': {
    freePlan: {value: '$10/mo/seat'},
    proPlan: {value: '$10/mo/seat'},
    proPlanPlus: {value: '$10/mo/seat'}
  },
  'Custom dashboard roles (Coming soon)': {
    freePlan: {value: ' '},
    proPlan: {value: ' '},
    proPlanPlus: {value: true}
  },
  'User Impersonation': {
    freePlan: {value: ' '},
    proPlan: {value: ' '},
    proPlanPlus: {value: true}
  },
};

export const b2bSaasFeatures = {
  'User limit': {
    freePlan: {value: '5'},
    proPlan: {value: 'Unlimited'},
    proPlanPlus: {value: 'Unlimited'}
  },
  'Invitation emails': {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Basic RBAC': {
    freePlan: {value: true},
    proPlan: {value: true},
    proPlanPlus: {value: true}
  },
  'Custom roles and permissions': {
    freePlan: {value: ' '},
    proPlan: {value: ' '},
    proPlanPlus: {value: true}
  },
  'Auto join / Request to join': {
    freePlan: {value: ' '},
    proPlan: {value: ' '},
    proPlanPlus: {value: true}
  },
  'Domain restrictions': {
    freePlan: {value: ' '},
    proPlan: {value: ' '},
    proPlanPlus: { value: true },
    titleTooltip: 'Restrict organization members to only specific email domains'
  },
};

export const supportAndCompliance = {
  'Full data exports': {
    freePlan: {value: true},
    proPlan: {value: true}
  },
  'Community Support': {
    freePlan: {value: true},
    proPlan: {value: true}
  },
  'Email Support': {
    freePlan: {value: true, toolTip: 'Billing, registration and abuse queries only.'},
    proPlan: {value: true}
  },
  'SOC2 Report': {
    freePlan: {value: ' '},
    proPlan: {value: true}
  },
  'GDPR / DPAs': {
    freePlan: {value: ' '},
    proPlan: {value: true}
  },
};
